import {
  Box, Grid, makeStyles, Typography,
} from '@material-ui/core';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import states from '../../modules/states';
import QuestionHeaderBox from '../QuestionHeaderBox';

function Q1Header() {
  const { stateCode } = useParams();
  const { primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    definitionBox: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    questionBox: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    headline: {
      fontWeight: 'bold',
    },
  }))();

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <QuestionHeaderBox color={primaryColor}>
          {/* <HelpIcon style={{ color: primaryColor, fontSize: 60 }} align="center" /> */}
          <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
            In {states[stateCode.toUpperCase()]}, do families have access to licensed child care?
          </Typography>
          <Typography variant="body1" align="left" style={{ marginTop: 10 }} gutterBottom>
            Quality child care helps children develop to their full potential and allows parents to work, which is crucial to our economy.
            However, many families lack access to care because there are not enough slots in licensed child care programs.
            The shortfall varies from state to state and community to community.
          </Typography>

          <Typography variant="body1" align="left" style={{ marginTop: 10 }} gutterBottom>
            Access to child care is measured by comparing the total number of slots in licensed child care to the number of children
            under 6 whose parents work.
          </Typography>

          <Typography variant="body1" align="left" style={{ marginTop: 10 }} gutterBottom>
            Access varies by the type of care: center- or home-based, infant or preschooler, etc.
            Use the graphics to explore access to child care in {states[stateCode.toUpperCase()]}.
          </Typography>
        </QuestionHeaderBox>
      </Grid>
    </Grid>
  );
}

export default Q1Header;
